import { Link } from "react-router-dom";
import { Container, Typography, Box, Button } from "@mui/material";
import { useLang } from "../context/LanguageContext";

export default function NotFound() {
  const { t } = useLang();

  return (
    <Box sx={{ backgroundColor: "#1a1a1a", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Container sx={{ textAlign: "center", color: "#f0f0f0" }}>
        <Typography variant="h1" sx={{ fontWeight: 700, color: "#1976d2" }}>
          {t("notFound.title")}
        </Typography>
        <Typography variant="h5" sx={{ mt: 2, opacity: 0.8 }}>
          {t("notFound.message")}
        </Typography>
        <Button
          component={Link}
          to="/"
          variant="contained"
          size="large"
          sx={{ mt: 4 }}
        >
          {t("notFound.back")}
        </Button>
      </Container>
    </Box>
  );
}
